import './App.css';
import { Route, Routes, HashRouter } from 'react-router-dom';
import Homepage from './Components/Homepage';
import GroupHealth from './Components_Products/GroupHealth';
import GroupPersonal from './Components_Products/GroupPersonal';
import GroupTerm from './Components_Products/GroupTerm';
import GroupGratuity from './Components_Products/GroupGratuity';
import GroupCredit from './Components_Products/GroupCredit';
import FireBurglary from './Components_Products/FireBurglary';
import OfficePolicy from './Components_Products/OfficePolicy';
import ShopInsurance from './Components_Products/ShopInsurance';
import SingleTransitInsurance from './Components_Products/SingleTransitInsurance';
import MarineOpenInsurance from './Components_Products/MarineOpenInsurance';
import SalesTurnOverInsurance from './Components_Products/SalesTurnOverInsurance';
import ProffessionalDoctors from './Components_Products/ProffessionalDoctors';
import ProffessionalCompanies from './Components_Products/ProffessionalCompanies';
import WorkmenCompensation from './Components_Products/WorkmenCompensation';
import DirectorsInsurance from './Components_Products/DirectorsInsurance';
import MotorFleetInsurance from './Components_Products/MotorFleetInsurance';
import GeneralLiability from './Components_Products/GeneralLiability';
import ProductLiability from './Components_Products/ProductLiability';
import CyberInsurance from './Components_Products/CyberInsurance';
import CrimeInsurance from './Components_Products/CrimeInsurance';
import Header from './Components_Products/Header';
import Footer from './Components_Products/Footer';
import ThankyouPopup from './Components_Products/ThankyouPopup';

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Header />
        <Routes>
          <Route path='/' element={<Homepage />} />
          <Route path='/GroupHealth' element={<GroupHealth />} />
          <Route path='/GroupPersonal' element={<GroupPersonal />} />
          <Route path='/GroupTerm' element={<GroupTerm />} />
          <Route path='/GroupGratuity' element={<GroupGratuity />} />
          <Route path='/GroupCredit' element={<GroupCredit />} />
          <Route path='/FireBurglary' element={<FireBurglary />} />
          <Route path='/OfficePolicy' element={<OfficePolicy />} />
          <Route path='/ShopInsurance' element={<ShopInsurance />} />
          <Route path='/SingleTransitInsurance' element={<SingleTransitInsurance />} />
          <Route path='/MarineOpenInsurance' element={<MarineOpenInsurance />} />
          <Route path='/SalesTurnOverInsurance' element={<SalesTurnOverInsurance />} />
          <Route path='/ProffessionalDoctors' element={<ProffessionalDoctors />} />
          <Route path='/ProffessionalCompanies' element={<ProffessionalCompanies />} />
          <Route path='/WorkmenCompensation' element={<WorkmenCompensation />} />
          <Route path='/DirectorsInsurance' element={<DirectorsInsurance />} />
          <Route path='/MotorFleetInsurance' element={<MotorFleetInsurance />} />
          <Route path='/GeneralLiability' element={<GeneralLiability />} />
          <Route path='/ProductLiability' element={<ProductLiability />} />
          <Route path='/CyberInsurance' element={<CyberInsurance />} />
          <Route path='/CrimeInsurance' element={<CrimeInsurance />} />
        </Routes>
        {/* <ThankyouPopup/> */}
        <Footer />
      </HashRouter>
    </div>
  );
}
export default App;
